import { Text, Center, Flex, VStack } from "@chakra-ui/react";
import { Emoji, type EmojiKey } from "../Emoji";
import { ImageKey } from "../PlaceholderImage/imageList";
import { PlaceholderImage } from "../PlaceholderImage";
import { useTranslations } from "next-intl";

interface EmptyStateProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  emoji?: EmojiKey;
  size?: number;
  placeholderImage?: ImageKey;
  imageSize?: number | string;
  isDescription?: boolean;
  propsTitle?: React.ComponentProps<typeof Text>;
  propsDescription?: React.ComponentProps<typeof Text>;
  minH?: string;
  titleSize?: string;
  isGrayscale?: boolean;
}

export default function CustomEmptyState({
  title,
  description,
  children,
  emoji,
  size = 10,
  placeholderImage,
  imageSize,
  isGrayscale = true,
  isDescription = true,
  propsTitle,
  propsDescription,
  minH,
  titleSize,
}: EmptyStateProps) {
  const t = useTranslations("common.coming_soon");
  return (
    <Center
      w="full"
      minH={minH ? minH : { base: "200px", md: "300px" }}
      display="flex"
      px={4}
      py={8}
      id="empty-state"
    >
      <Flex
        flexDirection="column"
        gap={4}
        maxW="sm"
        align="center"
        justify="center"
      >
        {placeholderImage ? (
          <Center
            width={
              imageSize ? `${imageSize}rem` : { base: "200px", md: "300px" }
            }
            id="empty-state-image"
          >
            <PlaceholderImage
              image={placeholderImage}
              width="60%"
              height="auto"
              grayscale={isGrayscale}
            />
          </Center>
        ) : emoji ? (
          <Emoji emoji={emoji || "sleeping-face"} size={size} />
        ) : null}
        <VStack gap={1}>
          <Text
            textStyle={titleSize ? titleSize : { base: "lg", md: "xl" }}
            fontWeight="semibold"
            color="themeColor.fg.title"
            textAlign="center"
            {...propsTitle}
          >
            {title || t("title")}
          </Text>
          {isDescription && (
            <Text
              fontSize="sm"
              fontWeight="medium"
              color="themeColor.fg.muted"
              textAlign="center"
              {...propsDescription}
            >
              {description || t("description")}
            </Text>
          )}
        </VStack>
        {children}
      </Flex>
    </Center>
  );
}
